export default "__VITE_ASSET__qg7p3uvq__"